import { ProgramType } from "../../../models/Program";

export const isProgramTypeWithoutCompetenceSection = (
  programTypeId: number | null | undefined,
) =>
  programTypeId === ProgramType.BasicEducationPrograms ||
  programTypeId === ProgramType.MiddleSchoolShorterThanThreeYearsPrograms ||
  programTypeId === ProgramType.MiddleSchoolThreeYearsPrograms ||
  programTypeId === ProgramType.MiddleSchoolLongerThanThreeYearsPrograms ||
  programTypeId === ProgramType.ForeignLanguageLearningPrograms ||
  programTypeId === ProgramType.BasicArtsPrograms ||
  programTypeId === ProgramType.MiddleSchoolArtsProgramsLongerThanThreeYears ||
  programTypeId === ProgramType.CroatianLanguageForForeigners;

// Program types that have a "Moduli i skupovi ishoda učenja" section.
// Shared so the edit and details views show the modules section for the same types.
export const isProgramTypeWithModuleSection = (
  programTypeId: number | null | undefined,
) =>
  programTypeId === ProgramType.TrainingPrograms ||
  programTypeId === ProgramType.CraftsAndArtsTrainingPrograms ||
  programTypeId === ProgramType.CraftsSpecializationPrograms ||
  programTypeId === ProgramType.RefinementPrograms ||
  programTypeId === ProgramType.NewVocationalCurriculum;

